/**
 * SA-1308: the mail-gateway banners a triage row leaves out of an email's own
 * words. A closed list of the two compass-staging's mail carries (survey of its
 * 2,663 stored inbound emails, 19 Oct 2026); a new banner is one entry here and
 * one test case. A banner is removed only where it opens or closes the words:
 * one in the middle stays, and the message itself always shows it. Outlook's
 * text/plain bold wraps the banner in markers (`*⚠CAUTION:* This email …`); they
 * are read around the label, the sentence or the whole banner. Pure.
 */

const escape = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** A fixed sentence as a pattern: any run of whitespace where it has a space. */
const words = (sentence: string) => sentence.split(' ').map(escape).join('\\s+')

/** An optional emphasis marker: `*`, `**`, `_` or `__`. */
const MK = '(?:\\*{1,2}|_{1,2})?'

/** Opens 955 emails, word for word identical; the sign may be missing or plain. */
const CAUTION = `${MK}(?:⚠️?\\s*)?CAUTION:${MK}\\s*${MK}${words('This email may contain requests related to bank or payment information or changes. Please contact the sender via a trusted channel to verify this information before taking any action.')}${MK}`

/** Opens 26 emails (and is all they hold) and closes 40 more, between two underscore rules. */
const MIMECAST_OPEN = `_{10,}\\s+${MK}${words('This email has been scanned for viruses and malware by Mimecast.')}${MK}\\s+${MK}${words('To find out more, visit our website https://www.mimecast.com/.')}${MK}`

const LEADING = new RegExp(`^\\s*(?:${CAUTION}|${MIMECAST_OPEN}\\s+_{10,})\\s*`)
/** At the end the notice's closing rule may be gone: `splitQuoted` joins a
 * rule sitting directly above a quoted header to the quoted block. */
const CLOSING = new RegExp(`(?:${CAUTION}|${MIMECAST_OPEN}(?:\\s+_{10,})?)$`)
/** The closing banner is looked for only in the trimmed text's last
 * characters, longer than any banner: an anchored-at-the-end pattern tried at
 * every position of a long run of spaces or underscores is quadratic, and a
 * sender can write such a body. */
const TAIL = 2000

/** The text with every known banner opening it removed, with the blank lines
 * after each; a text that opens with none is returned as it is. */
export function stripLeadingBanners(text: string): string {
  let out = text
  for (let match = LEADING.exec(out); match; match = LEADING.exec(out)) out = out.slice(match[0].length)
  return out
}

/** The text with every known banner closing it removed, with the blank lines
 * before each; a text that closes with none is returned as it is. */
export function stripTrailingBanners(text: string): string {
  let out = text
  for (;;) {
    const trimmed = out.trimEnd()
    const from = Math.max(0, trimmed.length - TAIL)
    const match = CLOSING.exec(trimmed.slice(from))
    if (!match) return out
    out = trimmed.slice(0, from + match.index).trimEnd()
  }
}
